import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'intranet-madhos-angular';

  readLocalStorageValue(key) {
    return localStorage.getItem(key);
  }
}
